import Vue from 'vue';
import './ypm/assets/css/global.scss';
import './ypm/assets/css/nprogress.css';
import App from './ypm/App.vue';
import router from './ypm/router';
import SvgIcon from './ypm/components/SvgIcon.vue';

Vue.component('svg-icon', SvgIcon);
Vue.config.productionTip = false;
new Vue({ router, render: h => h(App) }).$mount('#app');
